import { cn } from '@/utils';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import React from 'react';
import toast from 'react-hot-toast';

export const NewsletterForm = () => {
  const [Email, setEmail] = React.useState(``);

  const handleFormSubmission = (e: any, currentEmail: string) => {
    e.preventDefault();
    const data = JSON.stringify({
      email: currentEmail,
    });

    const config = {
      method: `post`,
      maxBodyLength: Infinity,
      url: `https://content-panel.lvl.fit/api/collectEmails`,
      headers: {
        'Content-Type': `application/json`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        //console.log` RESPONSE`, JSON.stringify(response.data));
        toast.success(`Email Added Successfully`);
        setEmail(``);
      })
      .catch((error: any) => {
        //console.log`error while adding email:`, error);
        toast.error(`Something went wrong`);
      });
  };

  return (
    <div className="">
      <form
        onSubmit={(e) => handleFormSubmission(e, Email)}
        className="flex bg-white rounded-2xl p-2"
      >
        <input
          value={Email}
          onChange={(e) => setEmail(e.target.value)}
          name="email"
          type="email"
          required
          placeholder="Enter your Email"
          className={[
            `grow`,
            `px-4`,
            `py-2`,
            `font-bold border-none focus:outline-none focus:ring-0`,
            `placeholder:font-thin`,
            `placeholder:text-[#B4A5F3] w-[30%]`,
          ].join(` `)}
        />
        <button
          onClick={(e) => handleFormSubmission(e, Email)}
          className={cn(`bg-[#7356e8] text-white w-10 h-10  rounded-full`)}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </form>
    </div>
  );
};
